import { QueryClient, QueryFunction } from '@tanstack/react-query';
import serviceFetcherToTQFunction from 'services/tq-adapter/serviceFetcherToTQFunction';
import serviceOptionsToTQOptions from 'services/tq-adapter/serviceOptionsToTQOptions';
import serviceToTQKey from 'services/tq-adapter/serviceToTQKey';
import { OneServiceWithParams } from 'types/services/services';

/**
 * Convert a service with params to tanstack query interface
 * @param service the service to use
 * @param params the params for the service
 * @param queryClient the tanstack query client
 * @returns the interface for tanstack query
 */
const serviceWithParamsToTQInterface = <Data, Params extends object>(
  service: OneServiceWithParams<Data, Params>,
  params: Params,
  queryClient: QueryClient,
) => {
  const queryKey = serviceToTQKey(service, params) as readonly unknown[];
  const queryFn = serviceFetcherToTQFunction(service, queryClient) as QueryFunction<Data, readonly unknown[]>;

  const options = serviceOptionsToTQOptions(service.options, params);

  return { queryKey, queryFn, ...options };
};

export default serviceWithParamsToTQInterface;
